import * as Yup from "yup";

// form field names
export type TFormFieldNames = "reported_odometer" | "reported_engine_hours" | "notes" | "reminder_interval"
  | "reminder_message" | "fault_codes" | /*"configuration_string" | */"maintodometerkm0" | "maintintervalkm0" | "maintodometerkm1" | "maintintervalkm1" |
  "maintodometerkm2" | "maintintervalkm2" | "maintodometerkm3" | "maintintervalkm3" |
  "maintodometerkm4" | "maintintervalkm4" | "maintodometerkm5" | "maintintervalkm5" |
  "maintodometerkm6" | "maintintervalkm6" | "maintodometerkm7" | "maintintervalkm7" |
  "maintodometerkm8" | "maintintervalkm8" | "maintodometerkm9" | "maintintervalkm9" |
  "maintenghourshr0" | "maintintervalhr0" | "maintenghourshr1" | "maintintervalhr1" |
  "maintenghourshr2" | "maintintervalhr2" | "maintenghourshr3" | "maintintervalhr3" |
  "maintenghourshr4" | "maintintervalhr4" |
  "maintfixedtimeft0" | "maintintervalft0" | "maintprenotifyft0" |
  "maintfixedtimeft1" | "maintintervalft1" | "maintprenotifyft1" |
  "maintfixedtimeft2" | "maintintervalft2" | "maintprenotifyft2" |
  "maintfixedtimeft3" | "maintintervalft3" | "maintprenotifyft3" |
  "maintfixedtimeft4" | "maintintervalft4" | "maintprenotifyft4";

// initial values for the form
export const maintenanceDetailsInitialValues = {
  reported_odometer: 0,
  reported_engine_hours: 0,
  notes: "",
  reminder_interval: "",
  reminder_message: "",
  fault_codes: "",
  // configuration_string: "", // disabled per client feedback

  // TODO: need to remove these values
  maintodometerkm0: 0,
  maintintervalkm0: 0,

  maintodometerkm1: 0,
  maintintervalkm1: 0,

  maintodometerkm2: 0,
  maintintervalkm2: 0,

  maintodometerkm3: 0,
  maintintervalkm3: 0,

  maintodometerkm4: 0,
  maintintervalkm4: 0,

  maintodometerkm5: 0,
  maintintervalkm5: 0,

  maintodometerkm6: 0,
  maintintervalkm6: 0,

  maintodometerkm7: 0,
  maintintervalkm7: 0,

  maintodometerkm8: 0,
  maintintervalkm8: 0,

  maintodometerkm9: 0,
  maintintervalkm9: 0,

  maintenghourshr0: 0,
  maintintervalhr0: 0,

  maintenghourshr1: 0,
  maintintervalhr1: 0,

  maintenghourshr2: 0,
  maintintervalhr2: 0,

  maintenghourshr3: 0,
  maintintervalhr3: 0,

  maintenghourshr4: 0,
  maintintervalhr4: 0,

  maintfixedtimeft0: 0,
  maintintervalft0: 0,
  maintprenotifyft0: 0,

  maintfixedtimeft1: 0,
  maintintervalft1: 0,
  maintprenotifyft1: 0,

  maintfixedtimeft2: 0,
  maintintervalft2: 0,
  maintprenotifyft2: 0,

  maintfixedtimeft3: 0,
  maintintervalft3: 0,
  maintprenotifyft3: 0,

  maintfixedtimeft4: 0,
  maintintervalft4: 0,
  maintprenotifyft4: 0,
}

export const maintenanceDetailsYupValidationSchema = Yup.object().shape({


});

// Form Initial Values
export const formInitialValues = {
  provider: "",
  contact_name: "",
  contact_phone: "",
  contact_email: "",
  notes: "",
  cost: 0,
  service_date: 0
};

export type TAddFormFieldNames = "service_date" | "provider" | "contact_name" | "contact_phone" | "contact_email" | "notes" | "cost" | "service_date";

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  // service_date: Yup.date().required("Service Date is required"),

  provider: Yup.string()
    .required('Provider is required'),

  cost: Yup.number()
    .required('Cost is required')
    .positive('Cost must be a positive number')
    .typeError('Cost must be a number'),

  contact_email: Yup.string()
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Please enter a valid email address'),
  contact_phone: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"), // Validation for exactly 10 digits
});